import { Navigate } from "../../../../../router-utils"

export default function OrganizationTemplatesPage() {
	return <Navigate to="/org/templates/quote-email-templates" replace />
}
